// Services
import callAPI from "../callApi";
import path from "../variables";

const Permissions = {
	getAll: (filter?: any) =>
		callAPI(
			"GET",
			`${path.base}/settings/permissions${filter ? filter : ""}`,
			"",
			"getting all Permissions"
		),
	create: (data: any) =>
		callAPI("POST", `${path.base}/settings/permissions`, data, "creating Permission"),
	linkToRole: (params: any, data: any) =>
		callAPI(
			"POST",
			`${path.base}/settings/role-permissions${params ? params : ""}`,
			data,
			"assigning Permission to Role"
		),
	unLinkToRole: (permissionUUID: string, params: any, data: any) =>
		callAPI(
			"PUT",
			`${path.base}/settings/role-permissions/${permissionUUID}${params}`,
			data,
			"unassigning Permission to Role"
		),
	details: (ID: any) =>
		callAPI("GET", `${path.base}/settings/permissions/${ID}`, "", "getting Details Permission"),
	update: (data: any, ID: any) =>
		callAPI("PUT", `${path.base}/settings/permissions/${ID}`, data, "updating Permission"),
	delete: (ID: any) =>
		callAPI("DEL", `${path.base}/settings/permissions/${ID}`, "", "deleting Permission"),
	forceDelete: (ID: any) =>
		callAPI("DEL", `${path.base}/settings/permissions/${ID}`, "", "deleting Permission"),
	restore: (ID: any) =>
		callAPI("DEL", `${path.base}/settings/permissions/restore/${ID}`, "", "restoring Permission"),
};

export default Permissions;
